import { enelytixBillingService as service } from "services/serviceStorage";
import { BaseApiResponse } from "common/types";
import { wrapRequest } from "common/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BillingFilter, BillingGridData } from "./types";

export const fetchEnelytixBillings = createAsyncThunk<{ data: BillingGridData[]; total: number; filter: BillingFilter }, BillingFilter>(
    'enelytixBilling/fetchEnelytixBillings',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<BillingGridData[]>>({
            handler: () => service.getEnelytixBilling(filter),
            showNotifications: true
        });

        const mappedData = {
            data: data?.result || [],
            total: data?.result.length || 0,
            filter
        }

        return mappedData;
    }
);

export const downloadEnelytixBillingSearchResult = createAsyncThunk<string, BillingFilter>(
    'enelytixBilling/downloadEnelytixBillingSearchResult',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<string>>({
            handler: () => service.downloadEnelytixBillingSearchResult(filter),
            showNotifications: true
        });

        return data?.result!;
    }
);